// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"71c8667a","345":"b875fdf2","453":"20359781"}[chunkId] + ".chunk.js";
};